module.exports = __webpack_public_path__ + "assets/img/00083.665531d4.png";